export default __webpack_public_path__ + "static/media/services-1.26805f78.jpg";